var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-table", {
    staticClass: "thresholds-table",
    attrs: { "vendor-options": _vm.vendorOptions },
    scopedSlots: _vm._u([
      {
        key: "validFrom",
        fn: function (data) {
          return [
            _vm._v(
              " " + _vm._s(_vm._f("formatDate")(data.row["validFrom"])) + " "
            ),
          ]
        },
      },
      {
        key: "validTo",
        fn: function (data) {
          return [
            _vm._v(
              " " + _vm._s(_vm._f("formatDate")(data.row["validTo"])) + " "
            ),
          ]
        },
      },
      {
        key: "actions",
        fn: function (data) {
          return [
            _c(
              "pui-button",
              {
                attrs: { small: true, icon: "edit" },
                on: {
                  click: function ($event) {
                    return _vm.editThresholdClicked(data.row)
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("thresholdsTab.editThreshold")) + " "
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }